export const emptyRecord = (fields) =>
  Object.fromEntries(fields.map((f) => [f.key, null]))

export const updateAtIndex = (arr, index, patch) =>
  arr.map((item, i) => (i === index ? { ...item, ...patch } : item))

export const flattenFields = (sections) =>
  sections.flatMap((s) => [
    ...(s.fields ?? []),
    ...(s.fieldgroups ?? []).flatMap((g) => g.fields ?? []),
  ])
export const mapRelationFields = (item, relationKeys) => {
  const updated = { ...item }
  relationKeys.forEach((key) => {
    if (!updated[key]) return
    updated[key] = Array.isArray(updated[key])
      ? updated[key].map((e) => e.uuid)
      : updated[key].uuid
  })
  return updated
}

const isRelationField = (f) =>
  f.type === 'relation' || f.type === 'relations' || f.type === 'dependent'

export const preparePayload = (payload, sections) => {
  const result = { ...payload }
  sections?.forEach((section) => {
    const relationKeys = flattenFields([section])
      .filter(isRelationField)
      .map((f) => f.key)
    if (relationKeys.length === 0) return

    if (section.repeater) {
      if (Array.isArray(result[section.key])) {
        result[section.key] = result[section.key].map((item) =>
          mapRelationFields(item, relationKeys),
        )
      }
    } else {
      Object.assign(result, mapRelationFields(result, relationKeys))
    }

    section.fieldgroups?.forEach((group) => {
      if (!group.repeater) return
      const groupRelationKeys = (group.fields ?? [])
        .filter(isRelationField)
        .map((f) => f.key)
      if (groupRelationKeys.length === 0) return
      if (Array.isArray(result[group.key])) {
        result[group.key] = result[group.key].map((item) =>
          mapRelationFields(item, groupRelationKeys),
        )
      }
    })
  })
  return result
}

export const evaluateCondition = (condition, data) => {
  const parentValue = data?.[condition.field].toString()
  const stringValue = condition.value.toString()
  const negated = stringValue[0] === '!'
  return negated
    ? parentValue !== stringValue.slice(1)
    : parentValue === stringValue
}
